export default __webpack_public_path__ + "static/feature3-6bd38fb30258d250c72dba03769f58f6.webp";